import React from 'react';
import { ProgressCircle, ToggleSwitch } from '@americanexpress/dls-react';

import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

import { DLSSize } from 'src/types/dls-size.enum';
import styles from './manageEmailPreferencesRow.module.scss';
import layout from 'src/styles/layout.module.scss';
import colors from 'src/styles/colors.module.scss';
import Selectors from 'src/utils/selectors';
import { DlsTypographyVariants } from 'src/types/dls-typography-variants.enum';

export class ManageEmailPreferencesRowViewModel {
    title: string;
    subtitle?: string;
    emailSelected: boolean;
    onClick: () => Promise<void>;
    className?: string;
    isLoading?: boolean;
}

export default function ManageEmailPreferencesRow({
    title,
    subtitle,
    emailSelected,
    className,
    onClick,
    isLoading
}: ManageEmailPreferencesRowViewModel): JSX.Element {
    const ariaLabel: string = `${title} switch button`;
    const idForAriaLabel: string = ariaLabel.replace(/\s/g, '');

    return (
        <div
            className={`${styles.emailPreferenceRow} ${className || ''}`}
            data-cy={Selectors.SpendSmart.EMAIL_PREFERENCE_ROW}
        >
            <div className={styles.titles}>
                <p
                    data-cy={Selectors.SpendSmart.EMAIL_PREFERENCE_ROW_TITLE}
                    className={`${DlsTypographyVariants.LABEL_3} ${styles.title}`}
                    aria-hidden={true}
                >
                    {title}
                </p>
                <Typography
                    data-cy={Selectors.SpendSmart.EMAIL_PREFERENCE_ROW_SUBTITLE}
                    className={colors.textWeak}
                    component="p"
                    variant={TypographyVariants.CAPTION}
                >
                    {subtitle}
                </Typography>
            </div>
            <div aria-live="polite" aria-busy={isLoading}>
                {isLoading ? (
                    <ProgressCircle data-cy={Selectors.General.LOADING_INDICATOR} size={DLSSize.SMALL} />
                ) : (
                    <ToggleSwitch
                        onClick={onClick}
                        checked={emailSelected}
                        aria-labelledby={idForAriaLabel}
                        data-cy={Selectors.SpendSmart.TOGGLE_EMAIL_PREFERENCES_BUTTON}
                    />
                )}
                <span id={idForAriaLabel} className={layout.screenReaderOnly}>
                    {ariaLabel}
                </span>
            </div>
        </div>
    );
}
